import React from "react";
import {CheckInput, TextLink} from "./AuthStyles";
import {ReactComponent as TickIcon} from "../../../assets/icons/tick.svg";
import Color from "../../../assets/Colors";

export default function Checker({name, type, value, title, defaultChecked, change}) {
   return (
      <div>
         <CheckInput type={type} value={value} name={name} id={name + value} defaultChecked={defaultChecked} onChange={change}/>
         <TextLink paddBtn="0" visibleborder="none" color={Color.textColor} as="label" className="thin labelCheck" htmlFor={name + value}>
            <span className="checkBox">
               <TickIcon className="tick" />
            </span>
            {title}
         </TextLink>
      </div>
   );
}

Checker.defaultProps = {
   type: "checkbox",
   value: "value",
   title: "title",
};
